import { DEFAULT_MAP_SOURCE } from '@env';

import { FsMapComponentType } from './map-component';

// This offset is to appropriately move the popup window above the marker
export const MAP_MARKER_POPUP_OFFSET = -12;

export type FsPopup = FsMapComponentType<
  typeof DEFAULT_MAP_SOURCE,
  google.maps.InfoWindow,
  __esri.Popup
>;
